import { notificationsPagePath } from "./notificationsRoutes";

const APPLICATION_UPDATE_HEADING = "Application update";
const LEGACY_TITLE_PREFIX = "Application update — ";
const LEGACY_NOTIFICATIONS_PATH = "/notifications";

/** @param {{ type?: string } | null | undefined} notification */
export function isApplicationRejectedNotification(notification) {
  return notification?.type === "application.rejected";
}

/** @param {{ type?: string, title?: string, payload?: { fullMessageHtml?: string, jobPostId?: string, jobTitle?: string } } | null | undefined} notification */
export function notificationHasRejectionLetter(notification) {
  if (!isApplicationRejectedNotification(notification)) return false;
  return Boolean(String(notification.payload?.fullMessageHtml || "").trim());
}

/**
 * List/dropdown copy for application.rejected notifications.
 * @param {{ title?: string, payload?: { jobTitle?: string } } | null | undefined} notification
 */
export function getApplicationRejectedListDisplay(notification) {
  const jobTitle = String(notification?.payload?.jobTitle || "").trim();
  if (jobTitle) {
    return { heading: APPLICATION_UPDATE_HEADING, subtitle: jobTitle };
  }
  const title = String(notification?.title || "").trim();
  if (title.startsWith(LEGACY_TITLE_PREFIX)) {
    return {
      heading: APPLICATION_UPDATE_HEADING,
      subtitle: title.slice(LEGACY_TITLE_PREFIX.length).trim() || "Role",
    };
  }
  if (title === APPLICATION_UPDATE_HEADING) {
    return { heading: APPLICATION_UPDATE_HEADING, subtitle: "" };
  }
  return { heading: APPLICATION_UPDATE_HEADING, subtitle: title || "" };
}

/** Rewrite stored `/notifications?…` links to the role-specific notifications page. */
export function normalizeNotificationActionHref(href, role) {
  const raw = String(href || "").trim();
  if (!raw.startsWith(LEGACY_NOTIFICATIONS_PATH)) return raw;
  const base = notificationsPagePath(role);
  const query = raw.includes("?") ? raw.slice(raw.indexOf("?")) : "";
  return `${base}${query}`;
}

/** Job details path for application.rejected (payload jobPostId or /jobs/ actionHref). */
export function applicationRejectedJobPath(notification) {
  if (!isApplicationRejectedNotification(notification)) return null;
  const jobPostId = String(notification.payload?.jobPostId || "").trim();
  if (jobPostId) return `/jobs/${encodeURIComponent(jobPostId)}`;
  const href = String(notification?.actionHref || "").trim();
  if (href.startsWith("/jobs/")) {
    const pathOnly = href.split("?")[0].split("#")[0];
    return pathOnly || null;
  }
  return null;
}

/**
 * Where a notification row should navigate (bell dropdown, etc.).
 * Application updates open the notifications page and highlight the entry.
 */
export function notificationOpenPath(notification, role) {
  if (isApplicationRejectedNotification(notification)) {
    const base = notificationsPagePath(role);
    const jobPostId = String(notification.payload?.jobPostId || "").trim();
    if (jobPostId) return `${base}?jobPostId=${encodeURIComponent(jobPostId)}`;
    const notificationId = String(notification?.id || "").trim();
    if (notificationId) return `${base}?notificationId=${encodeURIComponent(notificationId)}`;
    return base;
  }
  return normalizeNotificationActionHref(notification?.actionHref, role);
}
